import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    backgroundColor: 'grey.3',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    zIndex: '1018',
  }),
);

themeStyles.addBaseStyles('Content')(
  css({
    position: 'relative',
    padding: 'm',
    paddingRight: 'xl',
    margin: 'auto',
  }),
);

themeStyles.addBaseStyles('IconWrapper')(
  css({
    position: 'absolute',
    right: 0,
    top: '8px',
    cursor: 'pointer',
  }),
);

export default themeStyles;
